module.exports = {"selectpicker":{"none_selected_text":"Rien de sélectionné zzz"}};